import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../Component/Layout";
import { saveAs } from "file-saver";
import Select from "react-select";
import { PURCHASE_API } from "../../apiConfig";
import * as XLSX from "xlsx";
import {
  BarChart, Bar,
  LineChart, Line,
  PieChart, Pie,
  AreaChart, Area,
  XAxis, YAxis, Tooltip,
  CartesianGrid, ResponsiveContainer, Cell
} from "recharts";

const GRNDashboard = () => {

  const [grnList, setGrnList] = useState([]);
  const [poList, setPoList] = useState([]);
  const [productCodeList, setProductCodeList] = useState([]);
  // const [productGroupList, setProductGroupList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [view, setView] = useState("table");
  const [chartType, setChartType] = useState("bar");
  const [yearList, setYearList] = useState([]);

 const [filters, setFilters] = useState({
  year: "", month: "", fromDate: "", toDate: "",
  productCode: "", grn: "", po: "", productGroup: "",
  tileFilter: ""   // ADD THIS, remove status
});

  const [summary, setSummary] = useState({
    totalPO: 0,
    poToGrn: 0,
    inspected: 0,
    openPO: 0,
    totalGRN: 0
  });

  // ================= GRAPH DATA =================
  const graphData = [
  { name: "Total PO", count: summary.totalPO },
  { name: "PO → GRN", count: summary.poToGrn },
  { name: "Inspected", count: summary.inspected },
  { name: "Open PO", count: summary.openPO },
  { name: "Total GRN", count: summary.totalGRN }
];

  const COLORS = ["#3b82f6", "#22c55e", "#8b5cf6", "#ef4444", "#f59e0b"];

  // ================= EXPORT =================
  const handleExport = async () => {
    try {
      const res = await axios.get(`${PURCHASE_API}/grndb/export-grn`);
      const worksheet = XLSX.utils.json_to_sheet(res.data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "GRN");
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const file = new Blob([excelBuffer], { type: "application/octet-stream" });
      saveAs(file, "GRN_Data.xlsx");
    } catch (err) {
      console.error("Export error:", err);
    }
  };

  // ================= LOAD =================
  useEffect(() => {
    loadAllDropdowns();
    fetchSummary();
  }, []);

  useEffect(() => {
    fetchTableData(filters);
  }, [filters]);

  const loadAllDropdowns = async () => {
    try {
      const [grnRes, poRes, productCodeRes, yearRes] = await Promise.all([
        axios.get(`${PURCHASE_API}/grndb/grn-list`),
        axios.get(`${PURCHASE_API}/grndb/po-list`),
        axios.get(`${PURCHASE_API}/grndb/product-code-list`),
        axios.get(`${PURCHASE_API}/grndb/year-list`)
        // axios.get(`${PURCHASE_API}/grndb/product-group-list`)
      ]);
      setGrnList(grnRes.data || []);
      setPoList(poRes.data || []);
      setProductCodeList(productCodeRes.data || []);
      setYearList(yearRes.data || []);
      // setProductGroupList(productGroupRes.data || []);
    } catch (error) {
      console.error("Error loading dropdowns:", error);
    }
  };

  const fetchTableData = async (filterObj) => {
    try {
      const res = await axios.post(`${PURCHASE_API}/grndb/grn-dashboard`, filterObj);
      setTableData(res.data || []);
    } catch (error) {
      console.error("Error fetching table data:", error);
    }
  };

  const fetchSummary = async () => {
    try {
      const res = await axios.get(`${PURCHASE_API}/grndb/grn-summary`);
      setSummary(res.data);
    } catch (err) {
      console.error("Error fetching summary:", err);
    }
  };

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
  };

 const handleReset = () => {
  setFilters({
    year: "", month: "", fromDate: "", toDate: "",
    productCode: "", grn: "", po: "",  tileFilter: "",
       
  });
};

  // ================= STYLES =================
  const filterLabel = {
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 6,
    color: "#334155"
  };

  const kpiStyles = `
  .kpi-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 12px;
    margin: 20px 0 16px 0;
  }
  .kpi-card {
    background: #f3f4f6;
    border-radius: 12px;
    padding: 6px 8px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0 4px 10px rgba(0,0,0,0.06);
    cursor: pointer;
    transition: all 0.3s ease;
  }
  .kpi-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 20px rgba(0,0,0,0.12);
  }
  .kpi-card.blue   { border-left: 5px solid #3b82f6; }
  .kpi-card.green  { border-left: 5px solid #22c55e; }
  .kpi-card.purple { border-left: 5px solid #8b5cf6; }
  .kpi-card.red    { border-left: 5px solid #ef4444; }
  .kpi-card.yellow { border-left: 5px solid #f59e0b; }
  .kpi-title {
    font-size: 14px;
    color: #000;
    font-weight: 600;
  }
  .kpi-count {
    font-size: 14px;
    color: #000;
    margin-top: 4px;
  }
  .kpi-sub {
    font-size: 14px;
    color: #000;
    margin-top: 4px;
    align-self: flex-end;
  }
  `;
  
  const monthOptions = [
  { label: "January", value: "01" },
  { label: "February", value: "02" },
  { label: "March", value: "03" },
  { label: "April", value: "04" },
  { label: "May", value: "05" },
  { label: "June", value: "06" },
  { label: "July", value: "07" },
  { label: "August", value: "08" },
  { label: "September", value: "09" },
  { label: "October", value: "10" },
  { label: "November", value: "11" },
  { label: "December", value: "12" }
];


  return (
    <Layout>
      <style>{kpiStyles}</style>

      <div className="container-fluid p-4">

        {/* ================= HEADER ================= */}
        <h3 className="fw-bold">GRN Dashboard</h3>

        {/* ================= DATE FILTERS ================= */}
        <div className="row g-3 mt-2">

          <div className="col-md-2">
            <label style={filterLabel}>Year</label>
            <Select
              // options={[{ label: "2024", value: "2024" }, { label: "2025", value: "2025" }]}
              options={yearList.map(y => ({
                label: y.year.toString(),
                value: y.year.toString()
              }))}
              value={filters.year ? { label: filters.year, value: filters.year } : null}
              onChange={(s) => handleFilterChange("year", s ? s.value : "")}
              isClearable
              placeholder="All"
            />
          </div>

          <div className="col-md-2">
            <label style={filterLabel}>Month</label>
            <Select
              options={monthOptions}
              value={
                monthOptions.find(
                  (option) => option.value === filters.month
                ) || null
              }
              onChange={(s) => handleFilterChange("month", s ? s.value : "")}
              isClearable
              placeholder="All"
            />
          </div>

          <div className="col-md-2">
            <label style={filterLabel}>From</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={filters.fromDate}
              onChange={(e) => handleFilterChange("fromDate", e.target.value)}
            />
          </div>

          <div className="col-md-2">
            <label style={filterLabel}>To</label>
            <input
              type="date"
              className="form-control form-control-sm"
              value={filters.toDate}
              onChange={(e) => handleFilterChange("toDate", e.target.value)}
            />
          </div>

          <div className="col-md-2 d-flex align-items-end">
            <button
              className="btn btn-sm w-100"
              style={{ background: "#0047AB", color: "#fff", border: "1px solid #0047AB" }}
              onClick={handleReset}
            >
              Reset
            </button>
          </div>

        </div>

        {/* ================= ADV FILTERS ================= */}
        <div className="bg-light p-3 rounded-4 mt-2 border border-2">
          <div className="row g-3">

            <div className="col">
              <label style={filterLabel}>Product Code</label>
              <Select
                options={productCodeList.map(p => ({
                  label: `${p.productCode} - ${p.productDescription || ""}`,
                  value: p.productCode
                }))}
                value={
                  filters.productCode
                    ? productCodeList
                      .filter(p => p.productCode === filters.productCode)
                      .map(p => ({
                        label: `${p.productCode} - ${p.productDescription || ""}`,
                        value: p.productCode
                      }))[0]
                    : null
                }
                onChange={(s) => handleFilterChange("productCode", s ? s.value : "")}
                isClearable placeholder="Select..."
              />
            </div>

            <div className="col">
              <label style={filterLabel}>GRN Number</label>
              <Select
                options={grnList.map(g => ({ label: g.grn_number, value: g.grn_number }))}
                value={filters.grn ? { label: filters.grn, value: filters.grn } : null}
                onChange={(s) => handleFilterChange("grn", s ? s.value : "")}
                isClearable placeholder="Select..."
              />
            </div>

            <div className="col">
              <label style={filterLabel}>PO Number</label>
              <Select
                options={poList.map(p => ({ label: p.purchase_order_id, value: p.purchase_order_id }))}
                value={filters.po ? { label: filters.po, value: filters.po } : null}
                onChange={(s) => handleFilterChange("po", s ? s.value : "")}
                isClearable placeholder="Select..."
              />
            </div>

            

          </div>
        </div>

        {/* ================= KPI TILES ================= */}
<div className="kpi-grid">

  <div className="kpi-card blue" onClick={() => handleFilterChange("tileFilter", "")}>
    <div className="kpi-title">Total PO</div>
    <div className="kpi-count">{summary.totalPO}</div>
    <div className="kpi-sub">Purchase Orders</div>
  </div>

  <div className="kpi-card green" onClick={() => handleFilterChange("tileFilter", "poToGrn")}>
    <div className="kpi-title">PO → GRN</div>
    <div className="kpi-count">{summary.poToGrn}</div>
    <div className="kpi-sub">Converted to GRN</div>
  </div>

          <div
  className="kpi-card blue"
  onClick={() => handleFilterChange("tileFilter", "inspected")}
>
            <div className="kpi-title">Inspected</div>
            <div className="kpi-count">{summary.inspected}</div>
            <div className="kpi-sub">Inspected Receipt</div>
          </div>

  <div className="kpi-card red" onClick={() => handleFilterChange("tileFilter", "openPO")}>
    <div className="kpi-title">Open PO</div>
    <div className="kpi-count">{summary.openPO}</div>
    <div className="kpi-sub">Pending Receipt</div>
  </div>

  <div className="kpi-card yellow" onClick={() => handleFilterChange("tileFilter", "totalGRN")}>
    <div className="kpi-title">Total GRN</div>
    <div className="kpi-count">{summary.totalGRN}</div>
    <div className="kpi-sub">Goods Receipts</div>
  </div>

</div>

        {/* ================= TOGGLE + EXPORT ================= */}
        <div className="mt-4 mb-3 d-flex justify-content-between align-items-center">

          <div className="btn-group btn-group-sm">
            <button
              className="btn"
              style={{
                background: view === "table" ? "#0047AB" : "transparent",
                color: view === "table" ? "#fff" : "#0047AB",
                border: "1px solid #0047AB"
              }}
              onClick={() => setView("table")}
            >
              Table
            </button>
            <button
              className="btn"
              style={{
                background: view === "graph" ? "#0047AB" : "transparent",
                color: view === "graph" ? "#fff" : "#0047AB",
                border: "1px solid #0047AB"
              }}
              onClick={() => setView("graph")}
            >
              Graph
            </button>
          </div>

          <button
            className="btn btn-sm"
            style={{ background: "#0047AB", color: "#fff", border: "1px solid #0047AB" }}
            onClick={handleExport}
          >
            Export
          </button>

        </div>

        {/* ================= GRAPH ================= */}
    {view === "graph" && (
  <div style={{ background: "#f8fafc", borderRadius: "16px", padding: "20px" }}>

    <h5 style={{ fontWeight: "600", marginBottom: "15px" }}>GRN Status Overview</h5>

    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <select
        value={chartType}
        onChange={(e) => setChartType(e.target.value)}
        style={{ padding: "6px", marginBottom: "10px" }}
      >
        <option value="bar">Bar Chart</option>
        <option value="line">Line Chart</option>
        <option value="pie">Pie Chart</option>
        <option value="area">Area Chart</option>
      </select>
    </div>

    {chartType === "bar" && (
      <ResponsiveContainer width="100%" height={320}>
        <BarChart data={graphData} barCategoryGap="40%">
          <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e5e7eb" />
          <XAxis dataKey="name" tick={{ fontSize: 13, fill: "#6b7280" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 12, fill: "#6b7280" }} axisLine={false} tickLine={false} />
          <Tooltip />
          <Bar dataKey="count" radius={[10, 10, 0, 0]} barSize={40}>
            {graphData.map((_, i) => <Cell key={i} fill={COLORS[i]} />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    )}

    {chartType === "line" && (
      <ResponsiveContainer width="100%" height={320}>
        <LineChart data={graphData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="count"
                    stroke="#8b5cf6"
                    strokeWidth={3}
                  />
        </LineChart>
      </ResponsiveContainer>
    )}

    {chartType === "area" && (
      <ResponsiveContainer width="100%" height={320}>
        <AreaChart data={graphData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
                  <Area
                    type="monotone"
                    dataKey="count"
                    stroke="#8b5cf6"
                    fill="#c4b5fd"
                  />
        </AreaChart>
      </ResponsiveContainer>
    )}

    {chartType === "pie" && (
      <ResponsiveContainer width="100%" height={320}>
        <PieChart>
          <Pie data={graphData} dataKey="count" nameKey="name" outerRadius={100}>
            {graphData.map((_, i) => <Cell key={i} fill={COLORS[i]} />)}
          </Pie>
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    )}

  </div>
)}

        {/* ================= TABLE ================= */}
        {view === "table" && (
          <div style={{
            background: "#fff", borderRadius: "10px",
            padding: "15px", boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
          }}>
            <div className="table-responsive">
              <table className="table" style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    {["GRN Number", "PO Number", "Product Code", "UOM", "Batch Number","Status",
                      "Requirement Qty", "Received Qty", "Open PO"].map((h, i) => (
                      <th key={i} style={{
                        background: "#f5f6fa", fontWeight: "600", fontSize: "14px",
                        padding: "10px", borderBottom: "1px solid #ddd",
                        textAlign: i >= 6 ? "right" : "left"
                      }}>
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.length === 0 ? (
                    <tr>
                      <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
                        No records found
                      </td>
                    </tr>
                  ) : (
                    tableData.map((row, i) => (
                      <tr key={i}>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee" }}>{row.grn_number}</td>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee" }}>{row.purchase_order_id}</td>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee" }}>{row.product_code}</td>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee" }}>{row.uom}</td>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee" }}>{row.batch_number}</td>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee", fontWeight: 600, color:  row.inspection_status === "Inspected"  ? "#15803d" : "#dc2626" }}> {row.inspection_status} </td>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee", textAlign: "right" }}>{row.requirement_qty}</td>
                        <td style={{ fontSize: 14, padding: "10px", borderBottom: "1px solid #eee", textAlign: "right" }}>{row.received_qty}</td>
                        <td style={{
                          fontSize: 14, padding: "10px", borderBottom: "1px solid #eee",
                          textAlign: "right", fontWeight: 600,
                          color: Number(row.open_po_qty) > 0 ? "#dc2626" : "#15803d"
                        }}>
                          {row.open_po_qty}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            <div className="d-flex justify-content-between align-items-center mt-3">
              <div style={{ fontSize: 14 }}>
                Showing {tableData.length} results
              </div>
              <div>
                <button className="btn btn-sm btn-outline-secondary me-2">← Prev</button>
                <button className="btn btn-sm btn-outline-secondary">Next →</button>
              </div>
            </div>

          </div>
        )}

      </div>
    </Layout>
  );
};

export default GRNDashboard;